import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-style-three',
  templateUrl: './services-style-three.component.html',
  styleUrls: ['./services-style-three.component.scss']
})
export class ServicesStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
